// import $ from "jquery";
import baseClass from "./base";

// baseClass.OnReadyArrAdd(function () {
//     // Selectează toate elementele cu atributul data-toggle="tab"
//     $('[data-toggle="tab"]').off('click').on('click', function (e) {
//         e.preventDefault(); // Opriți acțiunea implicită a clicului

//         // Identifică tabul pe care s-a făcut clic și ținta asociată
//         var target = $(this).attr('data-bs-target');

//         // Ascunde toate tab-urile și conținuturile lor
//         $('.nav-link').removeClass('active');
//         $('.tab-pane').removeClass('show active');

//         // Afișează tab-ul activ și conținutul asociat
//         $(this).addClass('active');
//         $(target).addClass('show active');

//         // Încărcați datele necesare pentru tab dacă este necesar
//         //baseClass.loadDataAjax($(this)); // Dacă doriți să încărcați datele AJAX la comutarea tab-urilor

//         return false; // Împiedică urmărirea linkului
//     });
// });

function jsLinksCheckEach(obj) {
  if (obj.hasClass("true-each")) return;
  obj.addClass("true-each");

  let __meta_seo_useprefech = $("#__meta_seo_useprefech").attr("content");
  __meta_seo_useprefech = __meta_seo_useprefech == "1" ? 1 : 0;
  const fetch = obj.attr("data-eachfetch");

  if (fetch != undefined && fetch == "1" && __meta_seo_useprefech) {
    baseClass.loadPrefechAjax(obj);
  }

  const prefetch = obj.attr("data-eachprefetch");

  if (prefetch != undefined && prefetch == "1" && __meta_seo_useprefech) {
    var href = obj.attr("href");
    if (!href || href == undefined) href = obj.attr("data-href");
    if (href) {
      var url = href;
      url += url.indexOf("?") != -1 ? "&" : "?";
      url += "rt=ajax";

      const tag = document.createElement("link");
      tag.rel = "prefetch";
      tag.as = "document";
      tag.href = url;
      document.head.appendChild(tag);
    }
  }
}

baseClass.OnReadyArrAdd(function () {
  $(".js_al")
    .off("click")
    .on("click", function (e) {
      baseClass.loadDataAjax($(this));
      return false;
    })
    .each(function () {
      jsLinksCheckEach($(this));
    });
});

baseClass.OnReadyArrAdd(function () {
  $(".js_nl")
    .off("click")
    .on("click", function (e) {
      e.stopPropagation();
      return false;
    });
});

baseClass.OnReadyArrAdd(function () {
  $(".js_all")
    .off("click")
    .on("click", function (e) {
      baseClass.loadDataAjax($(this));
      return false;
    })
    .each(function () {
      jsLinksCheckEach($(this));
    });
});

baseClass.OnReadyArrAdd(function () {
  $(".js_alld")
    .off("click")
    .on("click", function (e) {
      baseClass.loadDataAjax($(this), undefined, "delete");
      return false;
    });
});

baseClass.OnReadyArrAdd(function () {
  $(".js_alhl")
    .off("click")
    .on("click", function (e) {
      baseClass.loadDataAjaxHistory($(this));
      return false;
    })
    .each(function () {
      jsLinksCheckEach($(this));
    });
});

baseClass.OnReadyArrAdd(function () {
  $(".js_al_h")
    .off("click")
    .on("click", function (e) {
      var targetid = $(this).attr("data-targetid");
      var showclass = $(this).attr("data-showclass");
      var hideclass = $(this).attr("data-hideclass");

      var isloaded = $(this).attr("data-isloaded");
      if (isloaded != undefined && isloaded == "1") {
        if ($("#" + targetid).is(":visible")) {
          if (showclass != undefined) {
            $(this).removeClass(showclass);
          }
          if (hideclass != undefined) {
            $(this).addClass(hideclass);
          }
          $("#" + targetid).hide();
        } else {
          if (showclass != undefined) {
            $(this).addClass(showclass);
          }
          if (hideclass != undefined) {
            $(this).removeClass(hideclass);
          }
          $("#" + targetid).show();
        }
        return false;
      }

      $(this).attr("data-isloaded", "1");
      if (showclass != undefined) {
        $(this).addClass(showclass);
      }
      if (hideclass != undefined) {
        $(this).removeClass(hideclass);
      }
      $("#" + targetid).show();

      baseClass.loadDataAjax($(this));
      return false;
    });
});

baseClass.OnReadyArrAdd(function () {
  $(".js_anchor")
    .off("click")
    .on("click", function (e) {
      var href = $(this).attr("href");
      if (!href) {
        href = $(this).attr("data-href");
      }
      if (!href) return false;

      var indent = $(this).data("indent");

      href = href.replace(/^#/, "");
      var t = href.split("#");
      if (t.length == 1) {
        baseClass.scrolltargid(t[0], indent);
        return false;
      }

      if (window.location.pathname == t[0])
      {
        baseClass.scrolltargid(t[1], indent);
        return false;
      }

      var params = {};
      params.href = t[0];
      params.scrolltargetid = t[1];
      params.scrollindent = indent;
      params.stopother = 0;

      baseClass.loadDataAjaxHistory(undefined, params);

      return false;
    });
});

var hostregexp = new RegExp(location.host);
baseClass.OnReadyArrAdd(function () {
  $("[href]").each(function () {
    if ($(this).hasClass("true-target")) return;
    $(this).addClass("true-target");

    var href = $(this).attr("href");
    if (hostregexp.test(href) || href.match(/^\//)) {
      // local link
    } else {
      // extern link
      var target = $(this).attr("target");
      if (!target) $(this).attr("target", "_blank");
      var rel = $(this).attr("rel");
      if (!rel) $(this).attr("rel", "nofollow");
    }
  });
});
